const SEPARATOR = '/';
export const build = (...components: Array<string | undefined>) =>
  components.filter((component) => component).join(SEPARATOR);
